/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ExpenseAccountsOut,
  HTTPValidationError,
  ListVendorBillsParams,
  PaginatedVendorBillOut,
  PayBillIn,
  VendorBillIn,
  VendorBillOut,
  VendorBillSummaryOut,
  VoidBillIn
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listVendorBillsResponse200 = {
  data: PaginatedVendorBillOut
  status: 200
}

export type listVendorBillsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listVendorBillsResponseSuccess = (listVendorBillsResponse200) & {
  headers: Headers;
};
export type listVendorBillsResponseError = (listVendorBillsResponse422) & {
  headers: Headers;
};

export type listVendorBillsResponse = (listVendorBillsResponseSuccess | listVendorBillsResponseError)

export const getListVendorBillsUrl = (params?: ListVendorBillsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/vendor-bills?${stringifiedParams}` : `/api/vendor-bills`
}

/**
 * @summary List Vendor Bills
 */
export const listVendorBills = async (params?: ListVendorBillsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listVendorBillsResponse> => {

  return apiFetch<listVendorBillsResponse>(getListVendorBillsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVendorBillsQueryKey = (params?: ListVendorBillsParams,) => {
    return [
    `/api/vendor-bills`, ...(params ? [params] : [])
    ] as const;
    }


export const getListVendorBillsQueryOptions = <TData = Awaited<ReturnType<typeof listVendorBills>>, TError = HTTPValidationError>(params?: ListVendorBillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVendorBills>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVendorBillsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVendorBills>>> = ({ signal }) => listVendorBills(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVendorBills>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListVendorBillsQueryResult = NonNullable<Awaited<ReturnType<typeof listVendorBills>>>
export type ListVendorBillsQueryError = HTTPValidationError


export function useListVendorBills<TData = Awaited<ReturnType<typeof listVendorBills>>, TError = HTTPValidationError>(
 params: undefined |  ListVendorBillsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVendorBills>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listVendorBills>>,
          TError,
          Awaited<ReturnType<typeof listVendorBills>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListVendorBills<TData = Awaited<ReturnType<typeof listVendorBills>>, TError = HTTPValidationError>(
 params?: ListVendorBillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVendorBills>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listVendorBills>>,
          TError,
          Awaited<ReturnType<typeof listVendorBills>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListVendorBills<TData = Awaited<ReturnType<typeof listVendorBills>>, TError = HTTPValidationError>(
 params?: ListVendorBillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVendorBills>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Vendor Bills
 */

export function useListVendorBills<TData = Awaited<ReturnType<typeof listVendorBills>>, TError = HTTPValidationError>(
 params?: ListVendorBillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVendorBills>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListVendorBillsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createVendorBillResponse201 = {
  data: VendorBillOut
  status: 201
}

export type createVendorBillResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createVendorBillResponseSuccess = (createVendorBillResponse201) & {
  headers: Headers;
};
export type createVendorBillResponseError = (createVendorBillResponse422) & {
  headers: Headers;
};

export type createVendorBillResponse = (createVendorBillResponseSuccess | createVendorBillResponseError)

export const getCreateVendorBillUrl = () => {




  return `/api/vendor-bills`
}

/**
 * @summary Create Vendor Bill
 */
export const createVendorBill = async (vendorBillIn: VendorBillIn, options?: Parameters<typeof apiFetch>[1]): Promise<createVendorBillResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<createVendorBillResponse>(getCreateVendorBillUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(vendorBillIn)
  }
);}





export const getCreateVendorBillMutationKey = () => ['createVendorBill'] as const;

export const getCreateVendorBillMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVendorBill>>, TError,CreateVendorBillMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createVendorBill>>, TError,CreateVendorBillMutationVariables, TContext> => {

const mutationKey = getCreateVendorBillMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVendorBill>>, CreateVendorBillMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createVendorBill(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVendorBillMutationResult = NonNullable<Awaited<ReturnType<typeof createVendorBill>>>
    export type CreateVendorBillMutationBody = VendorBillIn
    export type CreateVendorBillMutationError = HTTPValidationError
    export type CreateVendorBillMutationVariables = {data: VendorBillIn}

    /**
 * @summary Create Vendor Bill
 */
export const useCreateVendorBill = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVendorBill>>, TError,CreateVendorBillMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createVendorBill>>,
        TError,
        CreateVendorBillMutationVariables,
        TContext
      > => {
      return useMutation(getCreateVendorBillMutationOptions(options), queryClient);
    }
    export type getVendorBillSummaryResponse200 = {
  data: VendorBillSummaryOut
  status: 200
}

export type getVendorBillSummaryResponseSuccess = (getVendorBillSummaryResponse200) & {
  headers: Headers;
};
;

export type getVendorBillSummaryResponse = (getVendorBillSummaryResponseSuccess)

export const getGetVendorBillSummaryUrl = () => {




  return `/api/vendor-bills/summary`
}

/**
 * @summary Get Vendor Bill Summary
 */
export const getVendorBillSummary = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getVendorBillSummaryResponse> => {

  return apiFetch<getVendorBillSummaryResponse>(getGetVendorBillSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVendorBillSummaryQueryKey = () => {
    return [
    `/api/vendor-bills/summary`
    ] as const;
    }


export const getGetVendorBillSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getVendorBillSummary>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVendorBillSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVendorBillSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVendorBillSummary>>> = ({ signal }) => getVendorBillSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVendorBillSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVendorBillSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getVendorBillSummary>>>
export type GetVendorBillSummaryQueryError = unknown


export function useGetVendorBillSummary<TData = Awaited<ReturnType<typeof getVendorBillSummary>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVendorBillSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVendorBillSummary>>,
          TError,
          Awaited<ReturnType<typeof getVendorBillSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVendorBillSummary<TData = Awaited<ReturnType<typeof getVendorBillSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVendorBillSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVendorBillSummary>>,
          TError,
          Awaited<ReturnType<typeof getVendorBillSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVendorBillSummary<TData = Awaited<ReturnType<typeof getVendorBillSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVendorBillSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Vendor Bill Summary
 */

export function useGetVendorBillSummary<TData = Awaited<ReturnType<typeof getVendorBillSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVendorBillSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVendorBillSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listExpenseAccountsResponse200 = {
  data: ExpenseAccountsOut
  status: 200
}

export type listExpenseAccountsResponseSuccess = (listExpenseAccountsResponse200) & {
  headers: Headers;
};
;

export type listExpenseAccountsResponse = (listExpenseAccountsResponseSuccess)

export const getListExpenseAccountsUrl = () => {




  return `/api/vendor-bills/expense-accounts`
}

/**
 * @summary List Expense Accounts
 */
export const listExpenseAccounts = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listExpenseAccountsResponse> => {

  return apiFetch<listExpenseAccountsResponse>(getListExpenseAccountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExpenseAccountsQueryKey = () => {
    return [
    `/api/vendor-bills/expense-accounts`
    ] as const;
    }


export const getListExpenseAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listExpenseAccounts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExpenseAccounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExpenseAccountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExpenseAccounts>>> = ({ signal }) => listExpenseAccounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExpenseAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListExpenseAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listExpenseAccounts>>>
export type ListExpenseAccountsQueryError = unknown


export function useListExpenseAccounts<TData = Awaited<ReturnType<typeof listExpenseAccounts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExpenseAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExpenseAccounts>>,
          TError,
          Awaited<ReturnType<typeof listExpenseAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExpenseAccounts<TData = Awaited<ReturnType<typeof listExpenseAccounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExpenseAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExpenseAccounts>>,
          TError,
          Awaited<ReturnType<typeof listExpenseAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExpenseAccounts<TData = Awaited<ReturnType<typeof listExpenseAccounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExpenseAccounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Expense Accounts
 */

export function useListExpenseAccounts<TData = Awaited<ReturnType<typeof listExpenseAccounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExpenseAccounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListExpenseAccountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type payVendorBillResponse200 = {
  data: VendorBillOut
  status: 200
}

export type payVendorBillResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type payVendorBillResponseSuccess = (payVendorBillResponse200) & {
  headers: Headers;
};
export type payVendorBillResponseError = (payVendorBillResponse422) & {
  headers: Headers;
};

export type payVendorBillResponse = (payVendorBillResponseSuccess | payVendorBillResponseError)

export const getPayVendorBillUrl = (billId: number,) => {




  return `/api/vendor-bills/${billId}/pay`
}

/**
 * @summary Pay Vendor Bill
 */
export const payVendorBill = async (billId: number,
    payBillIn: PayBillIn, options?: Parameters<typeof apiFetch>[1]): Promise<payVendorBillResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<payVendorBillResponse>(getPayVendorBillUrl(billId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(payBillIn)
  }
);}





export const getPayVendorBillMutationKey = () => ['payVendorBill'] as const;

export const getPayVendorBillMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof payVendorBill>>, TError,PayVendorBillMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof payVendorBill>>, TError,PayVendorBillMutationVariables, TContext> => {

const mutationKey = getPayVendorBillMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof payVendorBill>>, PayVendorBillMutationVariables> = (props) => {
          const {billId,data} = props ?? {};

          return  payVendorBill(billId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PayVendorBillMutationResult = NonNullable<Awaited<ReturnType<typeof payVendorBill>>>
    export type PayVendorBillMutationBody = PayBillIn
    export type PayVendorBillMutationError = HTTPValidationError
    export type PayVendorBillMutationVariables = {billId: number;data: PayBillIn}

    /**
 * @summary Pay Vendor Bill
 */
export const usePayVendorBill = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof payVendorBill>>, TError,PayVendorBillMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof payVendorBill>>,
        TError,
        PayVendorBillMutationVariables,
        TContext
      > => {
      return useMutation(getPayVendorBillMutationOptions(options), queryClient);
    }
    export type undoVendorBillPaymentResponse200 = {
  data: VendorBillOut
  status: 200
}

export type undoVendorBillPaymentResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type undoVendorBillPaymentResponseSuccess = (undoVendorBillPaymentResponse200) & {
  headers: Headers;
};
export type undoVendorBillPaymentResponseError = (undoVendorBillPaymentResponse422) & {
  headers: Headers;
};

export type undoVendorBillPaymentResponse = (undoVendorBillPaymentResponseSuccess | undoVendorBillPaymentResponseError)

export const getUndoVendorBillPaymentUrl = (billId: number,) => {




  return `/api/vendor-bills/${billId}/undo-payment`
}

/**
 * @summary Undo Vendor Bill Payment
 */
export const undoVendorBillPayment = async (billId: number,
    voidBillIn: VoidBillIn, options?: Parameters<typeof apiFetch>[1]): Promise<undoVendorBillPaymentResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<undoVendorBillPaymentResponse>(getUndoVendorBillPaymentUrl(billId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(voidBillIn)
  }
);}





export const getUndoVendorBillPaymentMutationKey = () => ['undoVendorBillPayment'] as const;

export const getUndoVendorBillPaymentMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof undoVendorBillPayment>>, TError,UndoVendorBillPaymentMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof undoVendorBillPayment>>, TError,UndoVendorBillPaymentMutationVariables, TContext> => {

const mutationKey = getUndoVendorBillPaymentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof undoVendorBillPayment>>, UndoVendorBillPaymentMutationVariables> = (props) => {
          const {billId,data} = props ?? {};

          return  undoVendorBillPayment(billId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UndoVendorBillPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof undoVendorBillPayment>>>
    export type UndoVendorBillPaymentMutationBody = VoidBillIn
    export type UndoVendorBillPaymentMutationError = HTTPValidationError
    export type UndoVendorBillPaymentMutationVariables = {billId: number;data: VoidBillIn}

    /**
 * @summary Undo Vendor Bill Payment
 */
export const useUndoVendorBillPayment = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof undoVendorBillPayment>>, TError,UndoVendorBillPaymentMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof undoVendorBillPayment>>,
        TError,
        UndoVendorBillPaymentMutationVariables,
        TContext
      > => {
      return useMutation(getUndoVendorBillPaymentMutationOptions(options), queryClient);
    }
    export type voidVendorBillResponse200 = {
  data: VendorBillOut
  status: 200
}

export type voidVendorBillResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type voidVendorBillResponseSuccess = (voidVendorBillResponse200) & {
  headers: Headers;
};
export type voidVendorBillResponseError = (voidVendorBillResponse422) & {
  headers: Headers;
};

export type voidVendorBillResponse = (voidVendorBillResponseSuccess | voidVendorBillResponseError)

export const getVoidVendorBillUrl = (billId: number,) => {




  return `/api/vendor-bills/${billId}/void`
}

/**
 * @summary Void Vendor Bill
 */
export const voidVendorBill = async (billId: number,
    voidBillIn: VoidBillIn, options?: Parameters<typeof apiFetch>[1]): Promise<voidVendorBillResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<voidVendorBillResponse>(getVoidVendorBillUrl(billId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(voidBillIn)
  }
);}





export const getVoidVendorBillMutationKey = () => ['voidVendorBill'] as const;

export const getVoidVendorBillMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof voidVendorBill>>, TError,VoidVendorBillMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof voidVendorBill>>, TError,VoidVendorBillMutationVariables, TContext> => {

const mutationKey = getVoidVendorBillMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof voidVendorBill>>, VoidVendorBillMutationVariables> = (props) => {
          const {billId,data} = props ?? {};

          return  voidVendorBill(billId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VoidVendorBillMutationResult = NonNullable<Awaited<ReturnType<typeof voidVendorBill>>>
    export type VoidVendorBillMutationBody = VoidBillIn
    export type VoidVendorBillMutationError = HTTPValidationError
    export type VoidVendorBillMutationVariables = {billId: number;data: VoidBillIn}

    /**
 * @summary Void Vendor Bill
 */
export const useVoidVendorBill = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof voidVendorBill>>, TError,VoidVendorBillMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof voidVendorBill>>,
        TError,
        VoidVendorBillMutationVariables,
        TContext
      > => {
      return useMutation(getVoidVendorBillMutationOptions(options), queryClient);
    }
